// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.order-modal {
  background: #fff;
  border-radius: 10px;
  padding: 32px 24px 24px 24px;
  min-width: 400px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
}
.close-btn {
  position: absolute;
  top: 18px;
  right: 18px;
  background: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 22px;
  cursor: pointer;
}
.order-info {
  margin-bottom: 24px;
}
.order-info > div {
  margin-bottom: 6px;
  font-size: 15px;
}
.slideshow {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.slide-img {
  max-width: 420px;
  max-height: 320px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.nav-btn {
    /* color: #fff; */
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-size: 22px;
  cursor: pointer;
  margin: 0 12px;
  /* transition: background 0.2s; */
}

.slide-indicator {
  text-align: center;
  font-size: 15px;
  color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/components/OrderModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;IACI,iBAAiB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb","sourcesContent":[".order-modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.5);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.order-modal {\n  background: #fff;\n  border-radius: 10px;\n  padding: 32px 24px 24px 24px;\n  min-width: 400px;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.18);\n}\n.close-btn {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  background: #e74c3c;\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: 22px;\n  cursor: pointer;\n}\n.order-info {\n  margin-bottom: 24px;\n}\n.order-info > div {\n  margin-bottom: 6px;\n  font-size: 15px;\n}\n.slideshow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n.slide-img {\n  max-width: 420px;\n  max-height: 320px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n.nav-btn {\n    /* color: #fff; */\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  font-size: 22px;\n  cursor: pointer;\n  margin: 0 12px;\n  /* transition: background 0.2s; */\n}\n\n.slide-indicator {\n  text-align: center;\n  font-size: 15px;\n  color: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
